import React from 'react';
import { Badge, Icon } from '../ui';
import { moduleOf, STATUS } from '../../theme/tokens';

// T0/T8 — En-tête de page homogène, piloté par le bloc `metadata` normalisé.
// Affiche titre + badge module + statut + version/date + sourceRef (traçabilité).
export const MetaHeader = ({ metadata = {}, icon, className = '' }) => {
  const mod = metadata.module ? moduleOf(metadata.module) : null;
  const st = metadata.status ? STATUS[metadata.status] : null;
  return (
    <div className={`mb-6 ${className}`}>
      <div className="flex items-center gap-3 flex-wrap">
        {icon && <Icon name={icon} className="h-6 w-6 text-blue-500" />}
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">{metadata.title || 'Sans titre'}</h1>
        {mod && (
          <Badge color={mod.color}>
            <Icon name={mod.icon} className="h-3 w-3" />
            {mod.label}
          </Badge>
        )}
        {st && <Badge color={st.color}>{st.label}</Badge>}
      </div>
      {metadata.description && (
        <p className="mt-2 text-gray-600 dark:text-gray-300">{metadata.description}</p>
      )}
      <div className="mt-2 flex items-center gap-3 text-xs text-gray-400 dark:text-gray-500 flex-wrap">
        {metadata.version && <span>v{metadata.version}</span>}
        {metadata.lastUpdate && <span>MàJ {metadata.lastUpdate}</span>}
        {metadata.sourceRef && <span className="font-mono">src: {metadata.sourceRef}</span>}
      </div>
    </div>
  );
};

export default MetaHeader;
